module.exports = __webpack_public_path__ + "media/application/images/svgs/database-eda8fd4cd8920283f863eda8213c24ba.svg";